import { defineMessages } from "react-intl";

const messages = defineMessages({
    play: {
        id: "audio.play",
    },
    submit: {
        id: "task.submit",
    },
    microphoneErrorTitle: {
        id: "microphoneError.title",
    },
    microphoneErrorDescription: {
        id: "microphoneError.description",
    },
    close: {
        id: "general.close",
    },
    useSafari: {
        id: "microphoneError.useSafari",
    },
});

export default messages;
